import type { EditorAPI } from '@/editorAPI';
import type { CompRef } from 'types/documentServices';
import { wixServicesInstallAndConnectToCMS } from './implementations/connectWixServicesToCMS';
import { ServiceSectionIds } from './types';

export const afterInstallProcess = {
  [ServiceSectionIds.SERVICE_1]: async (
    sectionRef: CompRef,
    editorAPI: EditorAPI,
  ) => {
    try {
      await wixServicesInstallAndConnectToCMS(
        sectionRef,
        editorAPI,
        ServiceSectionIds.SERVICE_1,
      );
    } catch (error) {
      console.error(
        'Failed to connect Service 2 to CMS. Please try again later.',
        error,
      );
    }
  },
  [ServiceSectionIds.SERVICE_2]: async (
    sectionRef: CompRef,
    editorAPI: EditorAPI,
  ) => {
    try {
      await wixServicesInstallAndConnectToCMS(
        sectionRef,
        editorAPI,
        ServiceSectionIds.SERVICE_2,
      );
    } catch (error) {
      console.error(
        'Failed to connect Service 2 to CMS. Please try again later.',
        error,
      );
    }
  },
};
